<style lang="less" scoped>
  .order-cover {
    width: 100%;
    padding: 16px;
    border-radius: 4px;
    background-color: #ffffff;
    border: solid 1px #d9dde8;
    display: flex;
    font-size: 16px;
  }
  .desktop {
    display: flex;
    width: 100%;
  }
  .mobile {
    display: none;
  }
  .status-component-cover {
    height: 84px;
    .order-status {
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      font-weight: bold;
    }
    .order-status-making {
      background: #449df3;
      color: white;
    }
    .order-status-waiting {
      background: #f0ac11;
      color: white;
    }
    .order-status-complete {
      background: #9b9b9b;
      color: white;
    }
  }
  .status-info-cover {
    flex: 1;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 15px;
  }
  .order-name {
    margin-bottom: 12px;
  }
  .order-address {
    margin-top: 2px;
    color: #8492a6;
  }
  .status-semi-info-cover {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: #8492a6;
    text-align: right;
    justify-content: center;
  }
  .order-cost {
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 5px;
  }
  .status-component-cover {
    width: 89px;
  }
  @media screen and (max-width: 560px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
      flex-direction: column;
    }
    .mobile-order-row {
      display: flex;
      width: 100%;
      align-items: center;
      &:first-of-type {
        padding-top: 0;
      }
    }
    .mobile-order-column {
      .flex-sizing {
        flex: 1;
      }
    }
    .mobile-status {
      padding: 8px;
      font-size: 14px;
    }
    .mobile-name {
      padding-left: 8px;
    }
    .mobile-order-price {
      padding-right: 16px;
    }
    .mobile-order-content {
      padding-top: 6px;
    }
    .gray {
      color: #8492a6;
    }
  }
</style>
<template lang="pug">
  .order-cover
    .desktop
      .status-component-cover
        status-component(:status="order.status")
      .status-info-cover
        strong.order-name {{order.name}}
        div
          div
            span {{firstPrescriptionName}}
            span(v-if="otherCount > 0") &nbsp;외 {{otherCount}}건
          div.order-address {{order.address}}
      .status-semi-info-cover
        .order-cost &#8361;{{Math.ceil(order.totalPrice).toLocaleString()}}
        .order-date {{order.created}}
    .mobile
      .mobile-order-row
        .mobile-order-column
          status-component.mobile-status(:status='order.status')
        .mobile-order-column.flex-sizing
          span.mobile-name.bold {{order.name}}
      .mobile-order-row.mobile-order-content
        .mobile-order-column
          div {{firstPrescriptionName}}
          div.gray {{order.address}}
      .mobile-order-row.mobile-order-content.gray
        .mobile-order-column.mobile-order-price &#8361;{{order.totalPrice.toLocaleString()}}
        .mobile-order-column.mobile-order-date {{order.created}}

</template>

<script>
import moment from 'moment';
import statusComponent from '@/components/order_status';

moment.locale('ko');

export default {
  props: ['order'],
  components: {
    statusComponent,
  },
  computed: {
    firstPrescriptionName() {
      const result = this.order.prescriptions[0].name;
      return result;
    },
    otherCount() {
      return this.order.prescriptions.length - 1;
    },
  },
  mounted() {
    this.order.created = moment(this.order.created).format('LL');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/mylist.vue